import React from "react";
import { Card, Typography } from "@mui/material";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import { red } from "@mui/material/colors";

function RulesCard({ rules }) {
  return (
    <Card
      sx={{
        boxSizing: "border-box",
        height: "100%",
        background: "#fcfcfc",
        boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
        padding: "10px",
      }}
      variant="outlined"
    >
      <ListItem>
        <ListItemAvatar>
          <Avatar sx={{ bgcolor: red[500] }}>
            <PriorityHighIcon />
          </Avatar>
        </ListItemAvatar>
        <Typography component="div" sx={{ fontSize: "3rem", fontWeight: 500 }}>
          Pravidlá
        </Typography>
      </ListItem>
      <hr style={{ margin: "1px 0 2px 0", color: "rgba(0,0,0,0.2)" }} />
      <List component="div" disablePadding>
        {rules.map((rule) => (
          <ListItem
            sx={{
              pl: 4,
            }}
          >
            <Typography
              key={rule}
              component={"paragraph"}
              sx={{ fontSize: "2rem", textIndent: "-24px" }}
            >
              <ArrowRightIcon />
              {rule}
            </Typography>
          </ListItem>
        ))}
      </List>
    </Card>
  );
}

export default RulesCard;
